import { Grid } from '@mui/material';
import React, { ReactElement } from 'react';
import { ChildrenProps } from '../interfaces/childrenProps';
import { ReactComponent as InfoIcon } from '../../authSimplified/images/info_icon.svg';
import { StyledAlertSimplified } from '../styles/simplifiedAlert';

/** Props for Alert Component */
interface SimplifiedAlertProps extends ChildrenProps {
  show: boolean | undefined;
  state?: 'success' | 'info' | 'warning' | 'error';
  gridClassName?: string;
  icon?: ReactElement | boolean;
  onClose?: () => void;
  className?: string;
}

/** Alert Component */
const SimplifiedAlert = ({
  show,
  children,
  state = 'info',
  gridClassName = '',
  icon = false,
  onClose,
  className,
}: SimplifiedAlertProps): React.JSX.Element => {
  return (
    <>
      {show && (
        <Grid item xs={12} className={gridClassName}>
          <StyledAlertSimplified
            className={`${className || ''}`}
            onClose={onClose}
            severity={state}
            icon={icon}
            variant="outlined">
            <Grid container>
              <Grid xs={1} className="infoIcon" item alignItems="center" justifyContent="center">
                <InfoIcon />
              </Grid>
              <Grid xs={10} item>
                {children}
              </Grid>
            </Grid>
          </StyledAlertSimplified>
        </Grid>
      )}
    </>
  );
};

export default SimplifiedAlert;
